import Head from 'next/head';
import { GetServerSideProps } from 'next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Mobile from '../../components/mobile';
import previewMain from '../../public/preview/preview-main.png';
import { getAllArticles } from '../../services/blog.service';
import { IArticles } from '../blog/blog.types';
import { WorksCardProps } from '../../components/works-card';
import { Footer, Header } from '../../components';
import staticWorks from '../../utils/works';
import menu from '../../utils/menu';

interface MobilePageProps extends Record<string, unknown> {
  posts: IArticles;
  works: Array<WorksCardProps>;
}

export default function MobilePage({ works, posts }: MobilePageProps) {
  return (
    <>
      <Head>
        <title>
          Mavinx Mobile Development: Creating Amazing Mobile Experiences
        </title>
        <meta
          property="og:title"
          content="Mavinx Mobile Development: Creating Amazing Mobile Experiences"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Mobile Development: Creating Amazing Mobile Experiences"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Mavinx develops engaging and delightful mobile experiences. Explore our native and cross-platform app development, UI/UX design, mobile strategy, and app store optimization capabilities. Learn how our mobile development team blends technical expertise, creativity, and user-centric design to create high-performance, intuitive apps. Mavinx develops iOS and Android applications and industry-specific mobile solutions."
        />
        <meta
          name="description"
          content="Mavinx develops engaging and delightful mobile experiences. Explore our native and cross-platform app development, UI/UX design, mobile strategy, and app store optimization capabilities. Learn how our mobile development team blends technical expertise, creativity, and user-centric design to create high-performance, intuitive apps. Mavinx develops iOS and Android applications and industry-specific mobile solutions."
        />

        <meta
          name="keywords"
          content="mobile development services, Mavinx mobile development, exceptional mobile experiences, user engagement, native app development, cross-platform app development, UI/UX design, mobile strategy, app store optimization, technical prowess, creativity, user-centric design, high-performance apps, iOS apps, Android apps, mobile solutions, industry-specific apps, mobile innovation, Mavinx mobile development partner"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <Mobile
        awards={{
          title: 'awards',
          leadText:
            'Leading review & rating piatforms name us the top mobile app development company',
          leadImage: '/ios/rate.png',
          list: [
            {
              image: '/awards/item-1.jpg',
              text: 'Top Web Developers in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-2.jpg',
              text: 'Top Web Design in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-3.jpg',
              text: 'Top Swift App Development in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-4.jpg',
              text: 'Top Web Developers in Ukraine',
              title: 'Goodfirm',
            },
            {
              image: '/awards/item-5.jpg',
              text: 'Upwork TOP RATED 2022',
              title: 'Upwork',
            },
            {
              image: '/awards/item-6.jpg',
              text: 'Top Web Developers Companies 2020',
              title: 'Appfutura',
            },
          ],
        }}
        works={works}
        posts={posts}
        domains={{
          domains: [
            { icon: '/domains/item-1.svg', label: 'Logistics <br /> Apps' },
            { icon: '/domains/item-2.svg', label: 'Real estate <br /> Apps' },
            { icon: '/domains/item-3.svg', label: 'Healthcare <br /> Apps' },
            { icon: '/domains/item-4.svg', label: 'Retail <br /> Apps' },
            { icon: '/domains/item-5.svg', label: 'Banking <br /> Apps' },
            { icon: '/domains/item-6.svg', label: 'NFT <br /> Development' },
            { icon: '/domains/item-7.svg', label: 'Enterprise <br /> Apps' },
            { icon: '/domains/item-8.svg', label: 'Communication <br /> Apps' },
          ],
        }}
      />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<
  MobilePageProps
> = async () => {
  try {
    const posts = await getAllArticles({ search: 'mobile' });

    const works = staticWorks;
    return {
      props: {
        works: [
          { ...works[0] },
          { ...works[1] },
          { ...works[4] },
          { ...works[3] },
        ],
        posts,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
